import {
    Address,
    Article,
    HandlingUnit,
    Packable,
    Shipment,
    ShipmentPriority,
    TransportOrder,
} from "../model/transportorder/transportOrder"
import { LengthMeasurementUnit } from "../model/transportorder/measurement"
import { v4 as uuid } from "uuid"
import {
    ExternalPriority,
    ExternalTransportOrder,
} from "@/client/transportorder-hub/model"
import { ExternalGoods } from "@/client/transportorder-hub/goods.model"
import { createExternalGoodsCargoMaterial } from "@/helper/transportOrderGoodsHelper"
import {
    createExternalCurrentTransportLeg,
    createExternalEndOfTransportChain,
    createExternalStartOfTransportChain,
} from "@/helper/transportOrderBundleHelper"

export const createEmptyAddress = (): Address => ({ street: "", city: "", postal_code: "", country: "DE" })

export const createHandlingUnit = (content: Packable[] = []): HandlingUnit => ({
    type: "HANDLING_UNIT",
    _frontendKey: `${uuid()}`,
    content: content,
    stacking_factor: 1,
    quantity: 1,
    packaging_material_id: "EURO",
    dimension: {
        length: { value: 800, unit: LengthMeasurementUnit.MMT },
        width: { value: 1200, unit: LengthMeasurementUnit.MMT }
    }
})

export const createEmptyArticle = (): Article => ({
    type: "ARTICLE",
    _frontendKey: `${uuid()}`,
    quantity: 1,
    name: "VW Currywurst"
})

export const containsUrgentShipment = (shipments?: Shipment[]): boolean => {
    const shipmentPriority = shipments?.find(shipment => shipment.priority === ShipmentPriority.URGENT)?.priority
    return shipmentPriority === ShipmentPriority.URGENT
}

export const getShipmentFromTransportOrder = (transportOrder: TransportOrder, shipmentId: string): Shipment | undefined => {
    const shipments = (transportOrder._embedded?.shipments ?? [])
    return shipmentId ? shipments.find(it => it.id === shipmentId) : shipments[0]
}

export const createExternalTransportOrder =
    (transportOrderOverrides: Partial<ExternalTransportOrder> = {}, goods: ExternalGoods = createExternalGoodsCargoMaterial()): ExternalTransportOrder =>
        ({
            id: "8b7b9434-6e64-425d-b920-7b73c48e7bf4",
            bundle_id: "7b9f7c6b-2433-42ba-b682-de89fa4e5990",
            external_id: "Source-Document-Identifier",
            external_consignment_reference_number: "Consignment-Number-12345",
            priority: ExternalPriority.URGENT,
            proposed_vehicle_type: "MEDIUM_TRUCK",
            external_order_created_date: "2018-09-01T14:06:00Z",
            buyer: {
                name: "Audi AG - Tor 11",
                address: {
                    street: "Buyer street",
                    city: "Buyer city",
                    country: "BY",
                    postal_code: "66666"
                }
            },
            supplier: {
                name: "Continental Werk Frankfurt",
                address: {
                    street: "Guerickestraße 7",
                    postal_code: "60488",
                    city: "Frankfurt",
                    country: "DE"
                },
                external_identifiers: {
                    duns: "004380264",
                    plant_code: "901024039",
                    supplier_code: "TEST000002"
                },
            },
            freight_forwarder: {
                name: "Speedy Logistics GmbH",
                duns: "123456789",
                account_id: "ff-account-001",
                supplier_code: "FFSUPPLIER001",
                address: {
                    street: "Logistics Street 1",
                    postal_code: "12345",
                    city: "Logistic City",
                    country: "DE"
                }
            },
            requires_two_drivers: false,
            freight_payer: {
                name: "AUDI Ingolstadt",
            },
            process_indicator: "LTL",
            goods,
            start_of_transport_chain: createExternalStartOfTransportChain(),
            end_of_transport_chain: createExternalEndOfTransportChain(),
            current_transport_leg: createExternalCurrentTransportLeg(),
            cancelled: false,
            last_modified_at: "2022-04-19T12:45:42.968Z",
            etag: 0,
            ...transportOrderOverrides,
        })
